import styled, { css } from 'styled-components';
import { AlertIcon } from '../assets';
import Typography from '../typography/Typography';
export const DisclaimerContainer = styled.div `
  position: relative;

  display: flex;

  width: 100%;

  padding: 1.2rem;
  padding-left: 2.1rem;

  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};
  border: 1px solid
    ${({ theme, isCritical }) => isCritical ? theme.colors.text.critical : theme.colors.borders.default};

  background-color: ${({ theme, isCritical }) => isCritical
    ? theme.colors.background.critical
    : theme.colors.surface.interactiveDefault};

  word-break: break-word;

  ${({ disclaimerTitle }) => disclaimerTitle
    ? css `
          flex-direction: column;

          padding: 0 4.5rem 3.1rem;

          text-align: center;
        `
    : ''};
`;
export const CustomAlertIcon = styled(AlertIcon) `
  flex: none;
  margin-top: 0.5rem;
  width: 2.3rem;
  height: 2.8rem;

  ${({ hasTitle }) => hasTitle
    ? css `
          position: absolute;
          top: -3rem;
          height: 6rem;
          width: 6rem;
        `
    : css `
          margin-right: 1.9rem;
        `}
`;
export const DisclaimerTitle = styled(Typography) `
  padding: 4.3rem 0 1.3rem;
`;
export const DisclaimerDescription = styled(Typography) `
  max-width: 63rem;
`;
export const DisclaimerImg = styled.img `
  object-fit: cover;
`;
export const CustomLi = styled.li `
  margin-bottom: 0.5rem;
  list-style-type: disc;
`;
//# sourceMappingURL=styles.js.map